import { writable } from '@shared/lib/store'

/**
 * Drives the scrollbar hint button on the right edge of the sidebar
 * (`Sidebar.client#TocScrollHighlight`). Lives in its own module so the
 * legacy DDB Toc and the new PG Toc can both update the same store.
 */
export const scrollHintStore = writable({
  label: '',
  top: 0,
  scrollToElement: () => {},
})
